import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import { getEmployeesPath } from 'app/utils/routes';

import { UploadFinishedModalProps } from './types';

function UploadFinishedModal({ isOpen, onClose }: UploadFinishedModalProps) {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text as="h6">Thank you for your upload!</Text>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            You can return to the homepage, and we&apos;ll notify you by email once the import is
            complete!
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={() => navigate(getEmployeesPath())} mx="auto">
            Home
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UploadFinishedModal;
